// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebase: {
        apiKey: 'AIzaSyBib5BmTRyNvnZQTOp-UZ9rKWWV2sGgFi0',
        authDomain: 'ima-staging.dmtinstitute.com',
        databaseURL: 'https://dmti-ima.firebaseio.com',
        projectId: 'dmti-ima',
        storageBucket: 'dmti-ima.appspot.com',
        messagingSenderId: '217903150143',
        appId: '1:217903150143:web:db7a43b2081cc2426ff48a',
        measurementId: 'G-C3HYLH2134'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
